var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListingEditImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 7.91311L13.586 6.14661C13.4928 6.05327 13.3665 6.00057 13.2346 6C13.1027 5.99944 12.976 6.05107 12.882 6.14361L8.548 10.4101C8.48044 10.477 8.43313 10.5616 8.4115 10.6541L7.8995 12.8726L7 14.0001H8.414L8.985 13.4356L10.779 13.0216C10.869 13.0006 10.9515 12.9551 11.0175 12.8906L15.351 8.62311C15.398 8.57679 15.4354 8.52163 15.461 8.46078C15.4866 8.39994 15.4999 8.33464 15.5002 8.26863C15.5004 8.20263 15.4875 8.13723 15.4624 8.07621C15.4372 8.01519 15.4002 7.95976 15.3535 7.91311ZM10.669 11.8296L9.6085 10.7696L13.23 7.20411L14.29 8.26411L10.669 11.8296ZM7 15.0001H15V16.0001H7V15.0001Z",
    fill: "#005880"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListingEditImage);
export default __webpack_public_path__ + "static/media/listing-edit-image.9a0275f9b7cc825f4869536933edde39.svg";
export { ForwardRef as ReactComponent };